import * as bootstrap from 'bootstrap';
import jsKit from '../../../shared/modules/jsKit';

const getBootstrap = () => bootstrap;

const getDataParts = (target, dataItem) => jsKit.getDataParts(target, dataItem);

const getElement = (selector, parent = document) => {
  const root = typeof parent === 'string' ? document.querySelector(parent) : parent;
  return root ? root.querySelector(selector) : null;
};

const showElement = (element) => {
  if (!element) {
    return;
  }

  element.style.removeProperty('display');
};

const hideElement = (element) => {
  if (!element) {
    return;
  }

  element.style.display = 'none';
};

function closeProductOptions(el) {
  if (!el) {
    return;
  }

  const basketModal = el.closest('[data-basket-product-add]');
  if (!basketModal) {
    return;
  }

  basketModal.querySelectorAll('[data-product-options] .btn-check:not([data-default-checked])').forEach((input) => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  basketModal.addEventListener('hidden.bs.modal', () => {
    const basketContent = getElement('[data-product-basket-content]', basketModal);
    const productOptions = getElement('[data-product-options]', basketModal);

    if (basketContent) {
      basketContent.innerHTML = '';
      hideElement(basketContent);
    }

    showElement(productOptions);
  });
}

async function reloadBasketTeaser() {
  const teaser = getElement('#basket-teaser');
  if (!teaser) {
    return;
  }

  const data = await jsKit.requestUrl('/basket/loadBasketTeaser', 'text');
  if (typeof data !== 'undefined') {
    teaser.innerHTML = data;
  }
}

async function addProductToBasket(productId, selectedOption, optionsModal, amount, forceAdd, reloadBasket, triggerId) {
  if (!productId || !selectedOption) {
    return;
  }

  const basketLoader = getElement('#basket_loader');
  if (reloadBasket) {
    showElement(basketLoader);
  }

  let productAmount = amount;
  let forceAddProduct = forceAdd;

  if (typeof productAmount === 'undefined') {
    productAmount = getElement(`[data-shop="product-${productId}-amount"]`)?.value || 1;
  }

  if (typeof forceAddProduct === 'undefined') {
    forceAddProduct = 0;
  }

  if (Number.isNaN(Number(productAmount))) {
    productAmount = 1;
  }

  const addGratis = getElement(`#add_gratis_${productId}`)?.value == 1 ? 1 : 0;

  if (triggerId) {
    const trigger = getElement(triggerId);
    if (trigger) {
      trigger.classList.add('hs_loading');
      const loader = document.createElement('div');
      loader.className = 'hs_loader';
      trigger.appendChild(loader);
    }
  }

  const productPersonalization = { slots: {}, color: 0, font: 0 };
  document.querySelectorAll('.personalization-input').forEach((input) => {
    if (input.value !== '') {
      const key = input.dataset.slot;
      productPersonalization.slots[key] = input.value;
    }
  });

  const color = getElement('[name="colors"]:checked');
  if (color) {
    productPersonalization.color = color.value;
  }

  const font = getElement('#fonts');
  if (font) {
    productPersonalization.font = font.value;
  }

  const bootstrap = getBootstrap();
  const optionsModalInstance = optionsModal && bootstrap
    ? new bootstrap.Modal(optionsModal)
    : null;

  const formData = new FormData();
  formData.append('add_product[product_id]', productId);
  formData.append('add_product[option]', selectedOption);
  formData.append('add_product[amount]', productAmount);
  formData.append('add_product[force_add]', forceAddProduct);
  formData.append('add_product[personalization][color]', productPersonalization.color);
  formData.append('add_product[personalization][font]', productPersonalization.font);
  formData.append('add_product[add_gratis]', addGratis);

  Object.entries(productPersonalization.slots).forEach(([key, value]) => {
    formData.append(`add_product[personalization][slots][${key}]`, value);
  });

  const data = await jsKit.requestUrl('/basket/addProduct/', 'json', 'POST', formData);

  const productModal = getElement(`[data-shop="product-${productId}-options"]`);
  const productOptions = productModal ? getElement('[data-product-options]', productModal) : null;
  const basketContent = productModal ? getElement('[data-product-basket-content]', productModal) : null;

  if (data && data.validated == 2) {
    hideElement(productOptions);
    if (basketContent) {
      basketContent.innerHTML = data.content || '';
      showElement(basketContent);
    }

    if (optionsModalInstance) {
      optionsModal.addEventListener('shown.bs.modal', () => {
        document.body.removeAttribute('style');
      });
      optionsModalInstance.show();
    }
  } else if (data && data.validated == 1) {
    if (data.added) {
      if (reloadBasket) {
        window.location.reload();
      } else {
        await reloadBasketTeaser();
      }
    }

    hideElement(productOptions);
    if (basketContent) {
      basketContent.innerHTML = data.content || '';
      showElement(basketContent);
    }

    if (optionsModalInstance) {
      optionsModalInstance.show();
    }
  } else {
    if (reloadBasket) {
      hideElement(basketLoader);
    }

    window.showErrors(data);
  }

  if (reloadBasket) {
    hideElement(basketLoader);
  }

  if (triggerId) {
    const trigger = getElement(triggerId);
    if (trigger) {
      trigger.classList.remove('hs_loading');
      trigger.querySelector('.hs_loader')?.remove();
    }
  }
}

function showProductOptions(e) {
  const bootstrap = getBootstrap();
  if (!bootstrap) {
    return;
  }

  const btn = e.delegateTarget || e.currentTarget;
  const product = btn.closest('[data-shop="product-container"]');
  const optionsModal = getElement('[data-basket-product-add]', product);
  if (!optionsModal) {
    return;
  }

  const optionsModalInstance = new bootstrap.Modal(optionsModal);
  const preselected = getElement('#sizes-options .btn-check:checked', product);

  optionsModal.querySelectorAll('.btn-check:not([data-default-checked])').forEach((input) => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  if (preselected) {
    const option = preselected.dataset.attributeOption.split('-');
    addProductToBasket(option[0], option[1], optionsModal);
  } else {
    optionsModal.addEventListener('shown.bs.modal', () => {
      document.body.removeAttribute('style');
    });
    optionsModalInstance.show();
    showElement(getElement('[data-product-options]', optionsModal));
  }
}

export const productBasketEvents = [
  ['jsShowProductOptions', (e) => {
    e.preventDefault();
    showProductOptions(e);
  }],

  ['jsCloseProductOptions', (e) => {
    e.preventDefault();
    closeProductOptions(e.delegateTarget);
  }],

  ['jsAddProductToBasket', (e) => {
    const target = e.delegateTarget;
    const isChoiceInput = target.matches('.btn-check');

    if (!isChoiceInput) {
      e.preventDefault();
    }

    const [
      productId,
      selectedOption,
      amount,
      forceAdd,
      reloadBasket,
      triggerId,
    ] = getDataParts(target, 'jsAddProductToBasket');

    if (isChoiceInput) {
      target.setAttribute('checked', 'checked');
    }

    addProductToBasket(productId, selectedOption, null, amount, forceAdd, reloadBasket, triggerId);
  }],
];
